import styles from './landing-profit.module.scss'

const onboardingConfig = [
  {
    title: 'Экономия времени',
    text: 'Получайте точные ответы на ваши клинические вопросы за считанные секунды напрямую из актуальных клинических рекомендаций',
    imgWidth: 216,
    imgHeight: 97,
    imgAlt: 'AI-Bolit - умный помощник для врачей на основе искусственного интеллекта',
    imgClass: styles.img1,
    cardClass: styles.card1,
  },

  {
    title: 'Поддержка в сложных случаях',
    text: 'Используйте AI Bolit как «второе мнение» при работе с нестандартными клиническими ситуациями',
    imgWidth: 216,
    imgHeight: 125,
    imgAlt: 'Экономия времени при работе с клиническими рекомендациями благодаря AI-Bolit',
    imgClass: styles.img2,
    cardClass: styles.card2,
  },

  {
    title: 'Персонализированные ответы',
    text: 'Получайте информацию, адаптированную под пациента с учетом возраста, сопутствующих заболеваний и других факторов',
    imgWidth: 208,
    imgHeight: 168,
    imgAlt: 'Поддержка врачей в сложных клинических случаях с помощью искусственного интеллекта',
    imgClass: styles.img3,
    cardClass: styles.card3,
  },
]

export { onboardingConfig }
